
  <button class="btn btn-outline-success btn-lg mx-2" (click)="downloadapp()"> Download App
    <img src="/assets/images/play_prism_hlock_2x.png" width="100px">
  </button>

